import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appPhonemask]'
})
export class PhonemaskDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event: any) {
    const inputElement = this.el.nativeElement;
    const initialValue = inputElement.value;

    if (!initialValue) return;

    // Get the current cursor position
    const cursorPosition = inputElement.selectionStart;

    // Remove any non-numeric characters
    let numericValue = initialValue.replace(/\D/g, '');

    // Ensure the length does not exceed 10 digits
    if (numericValue.length > 10) {
      numericValue = numericValue.substr(0, 10);
    }

    // Format the phone number
    let formattedValue = '';
    if (numericValue.length > 6) {
      formattedValue = numericValue.replace(/^(\d{3})(\d{3})(\d{0,4})/, '($1) $2-$3');
    } else if (numericValue.length > 3) {
      formattedValue = numericValue.replace(/^(\d{3})(\d{0,3})/, '($1) $2');
    } else if (numericValue.length > 0) {
      formattedValue = numericValue.replace(/^(\d{0,3})/, '($1');
    }

    // Update the value
    inputElement.value = formattedValue;

    // Calculate new cursor position
    let newCursorPosition = cursorPosition;

    // Determine number of non-numeric characters before the cursor in the initial and formatted value
    const nonDigitCountBefore = initialValue.slice(0, cursorPosition).replace(/\d/g, '').length;
    const nonDigitCountAfter = formattedValue.slice(0, cursorPosition + (formattedValue.length - initialValue.length)).replace(/\d/g, '').length;
    newCursorPosition += nonDigitCountAfter - nonDigitCountBefore;

    // Ensure new cursor position is within the new formatted value length
    if (newCursorPosition > formattedValue.length) {
      newCursorPosition = formattedValue.length;
    }

    // Set the cursor position
    inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
  }

  // Prevent input of non-numeric characters
  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    // Allow: backspace, delete, tab, escape, enter, and .
    if ([46, 8, 9, 27, 13, 110, 190].indexOf(event.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
        // Allow: Ctrl+C
        (event.keyCode === 67 && (event.ctrlKey || event.metaKey)) ||
        // Allow: Ctrl+V
        (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
        // Allow: Ctrl+X
        (event.keyCode === 88 && (event.ctrlKey || event.metaKey)) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Prevent non-numeric input
    if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
        (event.keyCode < 96 || event.keyCode > 105)) {
      event.preventDefault();
    }
    // Prevent additional input if formatted value is at max length
    if (this.el.nativeElement.value.length >= 14 && event.keyCode !== 8 && event.keyCode !== 46) {
      event.preventDefault();
    }
  }
}